import base64url from 'base64url';
import type { FC } from 'react';

import { Button } from '@ipfabric/ui-components/Button/Button';
import type { SnapshotId } from '@ipfabric/utils';
import { Permissions } from 'containers/Permissions/Permissions';
import { apiEndpointToBaseUrl } from 'utils/apiEndpointToFullUrl';

type Props = {
  btnText: string;
  className?: string;
  snapshot: SnapshotId;
  sn: string;
};

export const DownloadDeviceJson: FC<Props> = (props) => (
  <Permissions requiredScope={['settings']}>
    <Button
      renderAs='anchor'
      className={props.className}
      href={apiEndpointToBaseUrl(
        `/snapshots/${props.snapshot}/devices/${base64url.encode(props.sn)}/json`,
      )}
      icon='fa-file-download'
      size='small'
      variant='plain'
    >
      {props.btnText}
    </Button>
  </Permissions>
);
